<header>
  <div id="header-fixed-height"></div>
  <div id="sticky-header" class="tg-header__area">
    <div class="container custom-container">
      <div class="row">
        <div class="col-12">
          <div class="tgmenu__wrap">
            <nav class="tgmenu__nav">
              <div class="logo">
                <a href="/home">
                  <img
                    *ngIf="portalConfig.portalLogoUrl"
                    [src]="portalConfig.portalLogoUrl"
                    alt="Logo"
                    style="max-height: 85px; max-width: 230px; width: auto; height: auto; object-fit: contain;"
                  />
                </a>
              </div>
              <div
                class="tgmenu__navbar-wrap tgmenu__main-menu d-none d-xl-flex"
              >
                <ul class="navigation">
                  <li><a href="/home">Home</a></li>
                  <li *appPortalFeature="'registration'">
                    <a href="/vendor-registration">New Vendor Registration</a>
                  </li>
                  <li
                    class="menu-item-has-children"
                    *appPortalFeature="'invoice'"
                  >
                    <a href="#">Add Invoice</a>
                    <ul class="sub-menu">
                      <li>
                        <a href="/vendor-invoice" *appPortalButton>
                          Vendor Invoice Submission
                        </a>
                        <a
                          href="/login?from=invoice"
                          *appPortalLoginRequired
                          class="login-required-link"
                        >
                          Vendor Invoice Submission
                        </a>
                      </li>
                      <li>
                        <a href="/multiple-invoices" *appPortalButton>
                          Multiple Invoice Submission
                        </a>
                        <a
                          href="/login?from=invoice"
                          *appPortalLoginRequired
                          class="login-required-link"
                        >
                          Multiple Invoice Submission
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div
                class="tgmenu__navbar-wrap tgmenu__main-menu d-none d-xl-flex tgmenu__action"
              >
                <ul *appPortalFeature="'login'" class="list-wrap">
                  <li class="header-btn login-btn">
                    <a href="/login"
                      ><img
                        src="../../assets/img/icons/login.svg"
                        alt="login"
                      />
                      &nbsp;Log in</a
                    >
                  </li>
                </ul>
                <ul *appPortalFeature="'profile'" class="navigation list-wrap">
                  <li class="menu-item-has-children header-btn login-btn">
                    <a href="#" class="header-btn login-btn">
                      <img
                        src="../../assets/img/icons/user.svg"
                        alt="profile"
                      />
                      &nbsp;Profile&nbsp;
                    </a>
                    <ul class="sub-menu">
                      <li>
                        <i class="clickable" (click)="navigateToProfile()"
                          >Go to Profile</i
                        >
                      </li>
                      <li>
                        <i class="clickable" (click)="logout()">Logout</i>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div class="mobile-nav-toggler">
                <i class="tg-flaticon-menu-1"></i>
              </div>
            </nav>
          </div>
          <!-- Mobile Menu  -->
          <div class="tgmobile__menu">
            <nav class="tgmobile__menu-box">
              <div class="close-btn"><i class="tg-flaticon-close-1"></i></div>
              <div class="nav-logo">
                <a href="index.html">
                  <img
                    *ngIf="portalConfig.portalLogoUrl"
                    [src]="portalConfig.portalLogoUrl"
                    alt="Logo"
                    style="max-height: 85px; max-width: 230px; width: auto; height: auto; object-fit: contain;"
                  />
                </a>
              </div>
              <div class="tgmobile__search">
                <form action="#">
                  <input type="text" placeholder="Search here..." />
                  <button><i class="fas fa-search"></i></button>
                </form>
              </div>
              <div class="tgmobile__menu-outer">
                <!--Here Menu Will Come Automatically Via Javascript / Same Menu as in Header-->
              </div>
              <div *appPortalFeature="'login'" class="list-wrap">
                <button class="before-login" (click)="navigateToVendorLogin()">
                  <img src="../../assets/img/icons/login.svg" alt="login" />
                  &nbsp;Log in
                </button>
              </div>
              <div *appPortalFeature="'profile'" class="list-wrap">
                <button
                  class="before-login menu-item-has-children header-btn login-btn"
                  (click)="toggleDropdown()"
                >
                  <img src="../../assets/img/icons/user.svg" alt="profile" />
                  &nbsp;Profile&nbsp;<span class="fa fa-chevron-down"></span>
                </button>
                <div class="dropdown-menu" [class.show]="isDropdownOpen">
                  <li>
                    <i class="clickable" (click)="navigateToProfile()"
                      >Go to Profile</i
                    >
                  </li>
                  <li><i class="clickable" (click)="logout()">Logout</i></li>
                </div>
              </div>
            </nav>
          </div>
          <div class="tgmobile__menu-backdrop"></div>
          <!-- End Mobile Menu -->
        </div>
      </div>
    </div>
  </div>
</header>

<script src="../assets/js/main.js"></script>
<router-outlet></router-outlet>
